import { BETRIEB_LABELS, ALL_BETRIEB_SCHLUESSEL, type BetriebSchluessel } from '@/lib/kontakt-labels';
import { Check } from 'lucide-react';

interface BetriebePickerProps {
  selectedBetriebe: BetriebSchluessel[];
  primaererBetrieb: BetriebSchluessel | null;
  onBetriebeChange: (betriebe: BetriebSchluessel[]) => void;
  onPrimaererBetriebeChange: (betrieb: BetriebSchluessel | null) => void;
}

export default function BetriebePicker({
  selectedBetriebe,
  primaererBetrieb,
  onBetriebeChange,
  onPrimaererBetriebeChange,
}: BetriebePickerProps) {
  const toggle = (schluessel: BetriebSchluessel) => {
    const next = selectedBetriebe.includes(schluessel)
      ? selectedBetriebe.filter((b) => b !== schluessel)
      : [...selectedBetriebe, schluessel];

    if (next.length === 1) {
      onPrimaererBetriebeChange(next[0]);
    } else if (!next.includes(schluessel) && primaererBetrieb === schluessel) {
      onPrimaererBetriebeChange(next[0] ?? null);
    } else if (next.length === 0) {
      onPrimaererBetriebeChange(null);
    }
    onBetriebeChange(next);
  };

  return (
    <div data-testid="betriebe-picker" className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {ALL_BETRIEB_SCHLUESSEL.map((schluessel) => {
          const active = selectedBetriebe.includes(schluessel);
          return (
            <button
              key={schluessel}
              type="button"
              onClick={() => toggle(schluessel)}
              className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium transition-all border
                ${active
                  ? 'bg-[#1B3A5C]/8 border-[#1B3A5C]/40 text-[#1B3A5C]'
                  : 'bg-transparent border-gray-200 text-gray-500 hover:border-gray-300'}`}
            >
              {active && <Check className="w-3 h-3" />}
              {BETRIEB_LABELS[schluessel]}
            </button>
          );
        })}
      </div>

      {selectedBetriebe.length > 1 && (
        <div>
          <p className="text-[10px] font-semibold text-gray-500 mb-1.5">Primärer Betrieb</p>
          <div className="flex flex-wrap gap-1.5">
            {selectedBetriebe.map((schluessel) => (
              <label
                key={schluessel}
                className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium cursor-pointer border transition-all
                  ${primaererBetrieb === schluessel
                    ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]'
                    : 'bg-gray-100 text-gray-500 border-transparent hover:bg-gray-200'}`}
              >
                <input
                  type="radio"
                  name="primaerer_betrieb"
                  value={schluessel}
                  checked={primaererBetrieb === schluessel}
                  onChange={() => onPrimaererBetriebeChange(schluessel as BetriebSchluessel)}
                  className="sr-only"
                />
                {BETRIEB_LABELS[schluessel]}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
